/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 初始化首页推荐缓存，生效于手动降级
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/cache/init/recommend`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
